// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2_9Tg","label":"Radio_label__DBdZk","checkMark":"Radio_checkMark__1iHdf","disabled":"Radio_disabled__1G9vw"};